export default __webpack_public_path__ + "static/media/correct.bcccb43e.mp3";